
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChangedHistoryModel } from '@/models/changed-history';

@Component
export default class ChangedHistory extends Vue {
    @Prop({default: []})
    private historiesChanged!: ChangedHistoryModel[];
}
